<template>
  <el-container class="home-container">
    <el-header>
      <div class="header-left">
        <el-image :src="src_logo"
                  class="logo"
                  fit="fill"></el-image>
        <span class="home-title"
              @click="goHome">美团 · 地图开放平台</span>
      </div>
      <div class="head-right">
        <span>您好！{{userInfo.name}}</span>
        <el-button style="margin-right: 20px;"
                   @click="logout">退出</el-button>

      </div>
    </el-header>
    <el-container>
      <el-aside>
        <el-menu router
                 :default-active="$route.path"
                 unique-opened>
          <el-menu-item class="submenu"
                        index="/console/home"
                        style="
                      font-family: PingFangSC-Semibold;
                      font-size: 16px;
                      color: rgba(0, 0, 0, 1);
                      font-weight: 600;
                    ">
            <template slot="title">
              <i class="el-icon-s-home"></i>
              <span>个人首页</span>
            </template>
          </el-menu-item>
          <el-submenu index="/1">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>Key 管理</span>
            </template>
            <el-menu-item index="/console/key">我的Key</el-menu-item>
            <!-- <el-menu-item index="/console/recycle">回收站</el-menu-item> -->
          </el-submenu>
          <el-submenu index="/2">
            <template slot="title">
              <i class="el-icon-data-analysis"></i>
              <span>流量管理</span>
            </template>
            <el-menu-item index="/console/flowmanage">配额管理</el-menu-item>
            <el-menu-item index="/console/flowdetail/flow">流量详情</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <!-- 路由占位符 -->
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// import http from '@/http/index.js'

export default {
  data() {
    return {
      src_logo: require('@/assets/img/meituan-logo.png'),
      userInfo: null
    };
  },
  methods: {
    goHome() {
      // this.$router.push('/');
    },
    login() {
      // window.location.href = `http://passport.fe.st.sankuai.com/account/unitivelogin?service=0db29d02&continue=https%3A%2F%2Flbs-map.map.test.sankuai.com%2Fapi%2Fuser%2Fredirect%3Fcontinue%3Dhttp%3A%2F%2Flbs-map.map.test.sankuai.com%2Fconsole`;
      window.location.href = `http://passport.fe.st.sankuai.com/account/unitivelogin?service=0db29d02&continue=https%3A%2F%2Flbs-map.map.test.sankuai.com%2Fapi%2Fuser%2Fredirect%3Fcontinue%3Dhttp%3A%2F%2Flocalhost%3A7070%2Fconsole%2Fhome`;
    },
    logout() {
      // http.user.logout()

      // let newUrl
      // if (href.indexOf('localhost') !== -1) {
      //   newUrl =
      //     'http://passport.fe.st.sankuai.com/account/signout?service=0db29d02&continue=http%3A%2F%2Fpassport.fe.st.sankuai.com%2Faccount%2Funitivelogin%3Fservice%3D0db29d02%26continue%3Dhttps%253A%252F%252Flbs-map.map.test.sankuai.com%252Fapi%252Fuser%252Fredirect%253Fcontinue%253Dhttp%3A%2F%2Flocalhost%3A7070%2Fconsole%2Fhome';
      // } else if (href.indexOf('test.sankuai') !== -1) {
      //   newUrl =
      //     'http://passport.fe.st.sankuai.com/account/signout?service=0db29d02&continue=http%3A%2F%2Fpassport.fe.st.sankuai.com%2Faccount%2Funitivelogin%3Fservice%3D0db29d02%26continue%3Dhttps%253A%252F%252Flbs-map.map.test.sankuai.com%252Fapi%252Fuser%252Fredirect%253Fcontinue%253Dhttp%3A%2F%2Flbs-map.map.test.sankuai.com%2Fconsole%2Fhome';
      // } else if (href.indexOf('st.sankuai') !== -1) {
      //   newUrl =
      //     'http://passport.meituan.com/account/signout?service=0db29d02&continue=http%3A%2F%2Flbs-map.map.st.sankuai.com%2Fconsole%2Fhome';
      // } else if (href.indexOf('meituan') !== -1) {
      //   newUrl =
      //     'https://passport.meituan.com/account/signout?service=0db29d02&continue=https%3A%2F%2Flbs.meituan.com%2Fconsole%2Fhome';
      // }
      // window.location.replace('/passport/logout')
      // 会走浏览器缓存 下面的这个方式
      const { host } = window.location;
      window.location.href = (window.location.protocol + host + '/passport/logout?web_url=' + encodeURIComponent(window.location.href))
    }
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
  }
};
</script>
<style scoped lang="less">
.home-container {
  height: 100%;
  background-color: #fafbfc;
}
.el-main {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.72);
  text-align: justify;
  line-height: 24px;
  font-weight: 400;
  padding: 0 30px 30px 30px;
  position: absolute;
  left: 200px;
  right: 0;
  top: 80px;
  bottom: 0;
  height: calc(100vh - 80px);
  overflow-y: scroll;
}
.el-header {
  background-color: #1a1a1a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 20px;
  .header-left {
    display: flex;
    align-items: center;
    .logo {
      width: 25px;
      height: 25px;
      // margin-top: 18px;
    }
    .home-title {
      font-size: 18px;
      color: #fff;
      font-family: MeituanType-Regular;
      line-height: 60px;
      float: left;
      // margin: 0 120px 0 10px;
      margin-left: 5px;
    }
    // .home-title:hover {
    //   cursor: pointer;
    // }
  }
  .head-right {
    .el-button {
      background-color: transparent;
      border: none;
      color: #fff;
    }
    .el-button:hover {
      color: rgba(255, 255, 255, 0.72);
    }
  }
}
.el-aside {
  background-color: #fff;
  height: calc(100vh - 80px);
  position: absolute;
  top: 80px;
  left: 0;
  width: 200px !important;
  .el-menu {
    border-right: none;
    width: 200px;
  }
}

/deep/ .el-submenu__title {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
  font-weight: 600;
  height: 46px;
  line-height: 46px;
  border-radius: 12px;
  margin-top: 5px;
}
/deep/ .el-submenu__title:hover {
  background-color: #f5f5f7 !important;
}
.submenu:hover {
  background-color: #f5f5f7 !important;
}
.el-menu-item {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  height: 46px;
  line-height: 46px;
  font-weight: 400;
  border-radius: 12px;
  min-width: 180px !important;
  padding-left: 46px;
}
/deep/ .el-menu-item:hover {
  background-color: #f5f5f7 !important;
}
/deep/ .el-menu-item.is-active {
  font-family: PingFangSC-Semibold;
  color: rgba(0, 0, 0, 1);
  font-weight: 600;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 231, 95, 1) 0%,
    rgba(255, 209, 0, 1) 100%
  );
}
</style>
